import * as InlineEdit from "@/components/InlineEdit";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { useActiveOrganization, useIsOrgOwner } from "@/hooks/organizations";
import { Pencil } from "lucide-react";

const Trigger = () => {
  const isOrgOwner = useIsOrgOwner();
  const currentOrganization = useActiveOrganization()!;
  const { setIsEditing } = InlineEdit.useInlineEdit();

  return (
    <div className="flex items-center gap-2">
      <h1 className="text-2xl font-bold">{currentOrganization.name}</h1>
      {isOrgOwner ? (
        <Pencil
          onClick={() => setIsEditing(true)}
          className="ml-2 inline h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700"
        />
      ) : (
        <BasicTooltip content="Only owners are allowed to edit">
          <Pencil className="ml-2 inline h-4 w-4 text-gray-300" />
        </BasicTooltip>
      )}
    </div>
  );
};

export default Trigger;
